// extracted by mini-css-extract-plugin
module.exports = {"settings":"ShortListSecondaryAction_settings__32jEu"};